const INTEGRATION_APPLICATION_GWS = 'GWS'

/**
 * Map M365 license reference objects into the licenseType shape used by Engage modals.
 * @param {Array} m365Licenses
 * @returns {Array<{ id: string, displayName: string }>}
 */
export const mapM365LicensesToLicenseType = (m365Licenses = []) =>
  m365Licenses
    .filter((license) => license != null && (license.licence_id || license.id))
    .map((license) => ({
      id: license.licence_id || license.id,
      displayName: license.product_display_name || license.licence_id || license.displayName || '',
    }))

const hasM365LicenseEntries = (m365Licenses) =>
  Array.isArray(m365Licenses) && m365Licenses.some((license) => license != null && (license.licence_id || license.id))

/**
 * Normalize employee license fields for the active integration.
 * Dual-integrated employees may have both m365Licenses and GWS licenseType;
 * never overwrite GWS licenseType with M365 SKUs when GWS is selected.
 *
 * @param {Object} employee
 * @param {string} [integrationApplicationName]
 * @returns {Object}
 */
export const normalizeEmployeeLicenseType = (employee, integrationApplicationName) => {
  if (!employee) return employee

  const isGws = integrationApplicationName === INTEGRATION_APPLICATION_GWS

  if (isGws) {
    // Keep API licenseType as-is when present (including an explicit empty array).
    // Do not invent [] when the field was omitted — merge can keep list-row data.
    return employee
  }

  if (hasM365LicenseEntries(employee.m365Licenses)) {
    return {
      ...employee,
      licenseType: mapM365LicensesToLicenseType(employee.m365Licenses),
    }
  }

  // M365 context: do not fall back to GWS licenseType when m365Licenses is empty
  return {
    ...employee,
    licenseType: [],
  }
}
